import getCookieValue from '../common/getCookieValue.js'
var callWebApp = function(para) {
    var utm_source = getCookieValue('utm_source'),
        utmReg = /sem-gdt-m/,
        cateMap = {
            sale: 'sale',
            job: 'job',
            jianzhi: 'job',
            house: 'house',
            car: 'car',
            shenghuo: 'huangye',
            pets: 'sale'
        },
        cate = ____loadCfg[0],
        local = ____json4fe.locallist[0].listname,
        title = document.title,
        ta = document.createElement('script')
        ta.type = 'text/javascript' 
        // 旧版调起APP下载
        // ta.src = '//down.58.com/js/tcb/callWbApp_min.js'
        // ta.onload = ta.readystatechange = function () {
    	//     var callWbApp = window.callWbApp
	    //     if (!ta.readyState || /loaded|complete/.test(ta.readyState)) {
	    // 	    if (!cate) {
	    // 	    	callWbApp()
	    // 	    } else {
	    // 		    callWbApp('', 'cate', {
	    // 			    type: cateMap[cate],
	    // 			    local: local,
	    // 			    title: title
	    // 	    	})
	    //     	}
        //     ta.onload = ta.readystatechange = null
	    //     }  
        // }
        // 新版调起APP下载
        ta.src = '//down.58.com/js/callWbApp_2019_min.js'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(ta, s)
            // 加延迟是为了确保初始化的时候 callWbApp方法存在  
            setTimeout(() => {  
                if (utmReg.test(utm_source)) {
                    callWbApp('' ,'protocol', {      
                        pid: '751', // 可选参数，置空或者不填将自动填充默认值, 默认值 751. 用于调起不成功，下载时使用的渠道号。用来统计下载来源           
                        jump: 'wbmain://jump/core/main?params=%7B%7D'  // 跳转协议,必填。 调起的pid，也需要在跳转协议中填写，用来统计调起来源     
                    });  
                };
            }, 500)
}

export default callWebApp()